import type { RouteRecordRaw } from 'vue-router'

import AdminLayout from '@/layouts/AdminLayout.vue'
import AdminDashboard from '@/apps/admin/pages/AdminDashboard.vue'
import AdminLogin from '@/apps/admin/pages/AdminLogin.vue'
import AdminNotFound from '@/apps/admin/pages/AdminNotFound.vue'
import AdminInitializationError from '@/apps/admin/pages/AdminInitializationError.vue'

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/login',
    name: 'admin-login',
    component: AdminLogin,
    meta: { appScope: 'admin', requiresAdminAuth: false }
  },
  {
    path: '/admin',
    name: 'admin-root',
    component: AdminLayout,
    meta: { appScope: 'admin', requiresAdminAuth: true },
    children: [
      {
        path: '',
        name: 'admin-index',
        redirect: { name: 'admin-dashboard' }
      },
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: AdminDashboard,
        meta: { titleKey: 'admin.nav.dashboard' }
      },
      {
        path: 'initialization-error',
        name: 'admin-initialization-error',
        component: AdminInitializationError,
        meta: { skipAdminInitialization: true }
      },
      {
        path: ':pathMatch(.*)*',
        name: 'admin-not-found',
        component: AdminNotFound,
        meta: { titleKey: 'admin.notFound.title' }
      }
    ]
  }
]
